import React, { useContext, useEffect, useState } from 'react'
import { firestore } from '../../../firebase'
import StateContext from '../../../StateContext'

function EditEquityElement({id}) {

    const appState = useContext(StateContext)

    const [equity, setEquity] = useState(0);
    const [konto, setKonto] = useState("");
    const [type, setType] = useState("");

    const [error, setError] = useState("");

    useEffect(() => {

        if (appState.userId) {
            try {
                const equityRef = firestore.collection("users").doc(appState.userId).collection("egenkapital").doc(id);
                equityRef.onSnapshot(doc => {
                    const equity = {id: doc.id, ...doc.data()}
                    setEquity(equity.sum);
                    setType(equity.type);
                    setKonto(equity.konto);
                });


            } catch (error) {
                setError("Kunne ikke oppdatere");
            }
        }

    }, [id, appState.userId])

    async function editHandler(e) {
        e.preventDefault();
        try {
            const equityRef = firestore.collection("users").doc(appState.userId).collection("egenkapital").doc(id);
            const data = {
                konto,
                sum: equity,
                type 
            }
            equityRef.update(data);
        } catch (error) {
            
        }
    }

    return (
        <form onSubmit={editHandler}>

            <label>Konto</label>
            <input className="form-control mb-2" value={konto} onChange={e => setKonto(e.target.value)} />

            <label>Type</label>
            <input className="form-control mb-2" value={type} onChange={e => setType(e.target.value)} />

            <label>Sum equity</label>
            <input className="form-control mb-2" value={equity} onChange={e => setEquity(e.target.value)} type="number" />

            {error && <div className="alert alert-danger">{error}</div>}
            <button className="btn btn-success">Lagre endringer</button>

        </form>
    )

}
export default EditEquityElement